/**
 * @generated SignedSource<<09c0f1013b66f21a4dccc7683559da3f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TeamAdminArchiveTeamMutation$variables = {
  isArchived: boolean;
  teamId: string;
};
export type TeamAdminArchiveTeamMutation$data = {
  readonly team: {
    readonly updateArchivedStatus: {
      readonly id: string;
      readonly isArchived: boolean;
      readonly members: ReadonlyArray<{
        readonly id: string;
      }>;
    };
  };
};
export type TeamAdminArchiveTeamMutation = {
  response: TeamAdminArchiveTeamMutation$data;
  variables: TeamAdminArchiveTeamMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isArchived"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "teamId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "teamId"
      }
    ],
    "concreteType": "TeamMutation",
    "kind": "LinkedField",
    "name": "team",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "isArchived",
            "variableName": "isArchived"
          }
        ],
        "concreteType": "Team",
        "kind": "LinkedField",
        "name": "updateArchivedStatus",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isArchived",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "members",
            "plural": true,
            "selections": [
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TeamAdminArchiveTeamMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TeamAdminArchiveTeamMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "c28f3a9be1c5090979884ad5da8cc9ce",
    "id": null,
    "metadata": {},
    "name": "TeamAdminArchiveTeamMutation",
    "operationKind": "mutation",
    "text": "mutation TeamAdminArchiveTeamMutation(\n  $isArchived: Boolean!\n  $teamId: ID!\n) {\n  team(id: $teamId) {\n    updateArchivedStatus(isArchived: $isArchived) {\n      id\n      isArchived\n      members {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4f89f10738feeb041a789295a4351e30";

export default node;
